import { BooleanField, Datagrid, DateField, DateTimeInput, EditButton, FunctionField, ImageField, List, maxValue, minValue, NumberField, RadioButtonGroupInput, ReferenceField, ReferenceInput, required, SelectInput, TextField, useNotify, useRecordContext, useRedirect, useRefresh } from 'react-admin';
import Chip from '@mui/material/Chip';
import { BooleanInput, Edit, NumberInput, SimpleForm, TextInput } from 'react-admin';
import { getAuthData, url_image } from '../constant/constant';
import { DateInput, getStringFromDate, MaterialUIPickers } from '../constant/DateInput';


const OnSuccess = () => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();
    notify(`Changes saved`);
    redirect('/your-collection');
    refresh();
};

const ChipTextField = ({ source }) => {
    const record = useRecordContext();
    // console.log("record", record);
    // console.log("record source", record[source]);
    const color = ["primary", "primary", "warning", "success"];
    return (<Chip variant="outlined" color={color[record["id"]]} label={record[source]} />);
};

const CustomImageField = ({ source, width, marginTop }) => {
    const record = useRecordContext();
    // console.log("record", record);
    // console.log("record source", record[source]);
    return (<img src={url_image+record[source]} width={width} style={{marginTop: marginTop}} />);
};

const statusValidation = (value, allValues) => {
    if (allValues["id_status"] == 1) {
        return 'Status harus berisi "Sedang Dilayani" atau "Selesai Dilayani"';
    }
    return undefined;
};

const alokasiFilters = [
    <DateInput source="waktu_kunjungan" 
        // views={["year", "month"]} 
        parse={val => getStringFromDate(val).substring(0,10) }
        inputFormat="dd MMMM yyyy"
        alwaysOn 
    />,
];

export const ReportQueueList = () => (
    <List sort={{ field: 'waktu_kunjungan', order: 'DESC' }}>
    {/* <List filters={alokasiFilters} > */}
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <CustomImageField source="foto_pengunjung_path" label="Foto Pengunjung" width={120} marginTop={0} />
            <TextField source="nama_pengunjung" />
            {/* <DateField source="id_kab" /> */}
            <ReferenceField label="Wilayah" source="id_kab" reference="master_kab" link={false} >
                <TextField source="nama_kab" />
            </ReferenceField>
            <TextField source="nama_petugas" />
            <TextField source="waktu_kunjungan" />
            <TextField source="waktu_panggilan" />
            <FunctionField
                source=""
                label="Durasi Waktu"
                render={(record) => {
                    const waktuPanggilan = new Date(record.waktu_panggilan);
                    const waktuKunjungan = new Date(record.waktu_kunjungan);
                    const perbedaanWaktu = waktuPanggilan.getTime() - waktuKunjungan.getTime();
                    const perbedaanMenit = Math.floor(perbedaanWaktu / (1000 * 60));
                    if(perbedaanMenit <= 0) {
                        return `-`;
                    }
                    return `${perbedaanMenit} menit`;
                }}
            />
            <NumberField source="meja" />
            {/* <NumberField source="id_status" /> */}
            <ReferenceField label="Status" source="id_status" reference="status" link={false} >
                {/* <TextField source="status" /> */}
                <ChipTextField source="status" />
            </ReferenceField>
            <BooleanField source="is_sudah_dipanggil" />
            {/* <EditButton/> */}
        </Datagrid>
    </List>
);


const transform = data => ({
    ...data,
    // waktu_panggilan: data.id_status==2?new Date().toISOString().replace('T', ' ').substring(0, 19):new Date().getFullYear()+'-'+("0"+(new Date().getMonth()+1)).slice(-2)+'-'+("0"+new Date().getDate()).slice(-2)+" 00:00:00",
    waktu_panggilan: data.id_status==2?new Date().toLocaleDateString("en-CA", {year:"numeric", month: "2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit", second:"2-digit", hour12: false}).replace(/,/g, ''):data.waktu_panggilan,
    is_sudah_dipanggil: data.id_status==2?0:1,
    nama_petugas: getAuthData()["username"]
})

export const QueueEdit = () => (
    <Edit transform={transform} mutationMode="optimistic" onSuccess={{ OnSuccess }} > 
        <SimpleForm style={{display: "flex", flexDirection: "row", flexWrap: "wrap-reverse", alignItems: "flex-end"}}>
            {/* <TextInput source="id" /> */}
            {/* <TextInput source="foto_pengunjung_path" /> */}
            
            <div style={{display: "flex", flexDirection: "column", marginRight: 20}}>
                <TextInput source="nama_pengunjung" disabled />
                {/* <DateInput source="id_kab" /> */}
                <ReferenceInput source="id_kab" reference="master_kab">
                    <SelectInput optionText="nama_kab" disabled />
                </ReferenceInput>
                <TextInput source="nama_petugas" disabled />
                <DateTimeInput source="waktu_kunjungan" disabled />
                
                {/* <DateTimeInput source="waktu_panggilan" validate={[required()]}
                    parse={val => getStringFromDate(val)+"wwww"} 
                
                /> */}

                {/* <ReferenceInput source="id_status" reference="status">
                    <SelectInput optionText="status" validate={[required(), statusValidation]}/>
                </ReferenceInput> */}
                <RadioButtonGroupInput source="id_status" label="Status" choices={[
                    { id: '1', name: 'Menunggu Antrean' },
                    { id: '2', name: 'Sedang Dilayani' },
                    { id: '3', name: 'Sudah Selesai' },
                ]} validate={[required(), statusValidation]} />
                {/* <NumberInput source="meja" validate={[required(), minValue(1), maxValue(4)]} /> */}
                <RadioButtonGroupInput source="meja" label="Meja" choices={[
                    { id: '1', name: 'Meja 1' },
                    { id: '2', name: 'Meja 2' },
                    { id: '3', name: 'Meja 3' },
                    { id: '4', name: 'Meja 4' },
                ]} validate={[required(), minValue(1), maxValue(4)]} />
            </div>
            <CustomImageField source="foto_pengunjung_path" width={300} marginTop={10} />
        </SimpleForm>
    </Edit>
);